export var ReferralFormType;
(function (ReferralFormType) {
    ReferralFormType["IFA"] = "ifa";
    ReferralFormType["SjpIFA"] = "sjp-ifa";
})(ReferralFormType || (ReferralFormType = {}));
